// src/components/Developers.jsx
import React, { useEffect, useState, useContext } from 'react'
import { getDeveloperList } from '../services/Api'
import { Link } from 'react-router-dom'
import { GlobalContext } from '../GlobalContext';

export default function Developers() {
  const BATCH_SIZE = 8
  const [visibleCount, setVisibleCount] = useState(BATCH_SIZE)
  const [developerList, setDeveloperList] = useState([])
  const { globalVar } = useContext(GlobalContext);


  const handleLoadMore = () => {
    setVisibleCount((prev) => Math.min(prev + BATCH_SIZE, developerList.length))
  }

  const getDeveloperData = async (ano) => {
    try {
      const response = await getDeveloperList()
      if (response.success) {
        setDeveloperList(response.data)
      } else {
        console.error('Error fetching developers')
      }
    } catch (error) {
      console.error('API error:', error)
    }
  }

  useEffect(() => {
    getDeveloperData()
  }, [])
console.log(developerList,'developerlist');

  const getImageUrl = (path) => `${globalVar}/${path}`;

  return (
    <section className="py-25 bg-gray-50">
      
      <h2 className="text-3xl font-bold text-center mb-8 text-gray-900">
        Premium Developers in the UAE
      </h2>
     <span className="block text-center mb-14 text-gray-900 mx-4 sm:mx-0">
  Explore top-tier developers with outstanding track records
</span>


<div className="max-w-7xl mx-auto px-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-8">
  {developerList.slice(0, visibleCount).map((dev) => (
    <Link
      key={dev.id}
      to={`/developer-detail/${dev.slug}`}
      className="block bg-white rounded-2xl shadow-lg p-6 flex flex-col items-center hover:shadow-2xl transition"
    >
      {/* Optional logo image */}
<img
  src={getImageUrl(dev.logo || dev.logo_url)}
  alt={dev.name}
  loading="lazy"
  className="w-24 h-24 object-contain rounded filter opacity-70 md:opacity-80 md:contrast-75 mb-2"
/>



<div className="hidden sm:block text-lg font-semibold text-gray-800 mb-1 text-center">
  {dev.name}
</div>



      {/* ✅ Show property count */}
<div className="text-base mt-1 md:text-sm text-gray-800 md:text-gray-500 text-center">
  {dev.properties_count > 0
    ? `${dev.properties_count} ${dev.properties_count === 1 ? 'Project' : 'Projects'}`
    : 'No Projects'}
</div>



    </Link>
  ))}
</div>


      {visibleCount < developerList.length && (
        <div className="mt-10 text-center">
          <button
            onClick={handleLoadMore}
            className="px-8 py-3 bg-teal-500 hover:bg-teal-600 text-white font-medium rounded-full transition"
          >
            Load More
          </button>
        </div>
      )}
      
    </section>
  
  )
}